import { render, staticRenderFns } from "./DepartmentSelectInputWidget.vue?vue&type=template&id=12151a7a&scoped=true"
import script from "./DepartmentSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./DepartmentSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12151a7a",
  null
  
)

export default component.exports